<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>标签管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>标签管理</h4>
        <p @click="addPic" :style="{'border':'none','color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">+新增标签</p>
      </div>

      <div class="tabsbody">
        <div class="search">
          <div class="name">
            <div style="margin-right:20px;white-space:nowrap;width:100px;">标签名称:</div>
            <!-- 模糊查询 -->
            <el-input v-model="labelName"
                      @keyup.enter.native="searchClick"
                      clearable
                      placeholder="请输入标签名称"></el-input>
          </div>
          <el-button @click="searchClick"
                     :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                     class="btn">搜索</el-button>
        </div>
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <labelmanagetable :tableData="picTableList"
                          @formSubmit="formSubmit"
                          @closeClick="closeClick"
                          @removeClick="removeClick"></labelmanagetable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <mydialog @changedialogFormVisible="changedialogFormVisible"
              @dialogSubmit="dialogSubmit"
              :title="title"
              :myform="myform"
              :label="label"
              :dialogFormVisible="tableDialogFormVisible"></mydialog>
  </div>
</template>

<script>
import { labelmanagetable, labeldialog } from "@/components/index";
import { mapActions } from "vuex";
import { listLib, updateLib, addLib, deleteLib } from "@/api/lib";
import { list, addLabel, deleteLabel, getLabel } from "@/api/customLabel";
import { getDate, formatConversion } from "@/plugins/getdate";
export default {
  components: {
    labelmanagetable: labelmanagetable,
    mydialog: labeldialog
  },
  watch: {
    "$store.state.user.dialogFormVisible" (data) {
      this.dialogFormVisible = data;
    },
    tableDialogFormVisible (data) {
      this.tableDialogFormVisible = data;
    }
  },
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      label: ['标签名称', '分类名称', '排序'],
      title: '新增标签',
      myform: { one: "", two: "", three: "" },
      tableDialogFormVisible: false,
      picTableList: [
        // {
        //   date:'2020-4-15',
        //   name:'政务图片库',
        //   picj:'52个',
        //   pics:'630张',
        // },
        // {
        //   date:'2020-4-15',
        //   name:'人文图片库',
        //   picj:'5个',
        //   pics:'30张',
        // },
        // {
        //   date:'2020-4-15',
        //   name:'政务图片库',
        //   picj:'0个',
        //   pics:'0张',
        // },
        // {
        //   date:'2020-4-15',
        //   name:'政务图片库',
        //   picj:'1234个',
        //   pics:'95487张',
        // },
      ],
      timeInt: '',
      isRefresh: false,

      labelName:''
    };
  },
  methods: {
    ...mapActions(["setDialogFormVisible"]),

    searchClick(){
      this.currentPage = 1
      let data = { keyword: this.labelName,page: (this.currentPage - 1), pageSize: this.pageSize }
      // console.log(data)
      this.listLibAsync(data)
    },


    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize }
      // console.log(data)
      this.listLibAsync(data)
    },


    //刷新表格
    refresh () {
      this.labelName = ''
      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },


    addPic () {
      this.tableDialogFormVisible = true;
      this.myform = { one: "", two: "", three: "0" }
      // this.$router.push('/contributor')
    },

    //子组件picmanagetable传递过来的方法：用于新增图片库
    dialogSubmit (data) {
      let { systemDate } = getDate();
      let willToPushData = {
        "labelName": data.one,
        "labelClass": data.two,
        "sort": data.three,
        "status": 0,
      };
      this.addLibAsync(willToPushData)
      // console.log(willToPushData)

    },

    //子组件dialog的方法：用于修改是否隐藏dialog的值   不予picmanagetable组件中的dialog组件重复
    changedialogFormVisible (data) {
      this.tableDialogFormVisible = data;
    },

    //修改图片库信息事件
    formSubmit (data) {
      let { systemDate } = getDate();
      let updateMsg = {
        labelName: data.one,
        labelClass: data.two,
        sort: data.three,
        createAt: data.createAt,
        status: data.status
      };
      this.updateLibAsync(updateMsg);
    },
    //删除图片库信息事件
    removeClick (data) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.deleteLibAsync(data.row.labelName)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },
    //关闭或开始图片库
    closeClick (data) {
      this.$confirm("确认修改状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let closeMsg = data.row;
          if (closeMsg.status === 0) {
            closeMsg.status = 1;
          } else {
            closeMsg.status = 0;
          }
          this.updateLibAsync(closeMsg);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },


    //删除图片库列表
    async deleteLibAsync (val) {
      let { status, data, message, errors } = await deleteLabel(val);
      if (status) {
        this.$message.success('删除成功！');
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //添加图片库信息
    async addLibAsync (val) {
      let { status, data, message, errors } = await addLabel(val);
      if (status) {
        this.changedialogFormVisible(false)
        this.$message.success("添加成功！");
        this.handleCurrentChange(1);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改图片库信息
    async updateLibAsync (val) {
      let { status, data, message, errors } = await updateLib(val);
      if (status) {
        this.$message.success("修改成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图片库列表
    async listLibAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await list(val);
      if (status) {
        this.picTableList = data;
        this.total = pagination.total

        for (let i = 0; i < this.picTableList.length; i++) {
          this.picTableList[i].createAtMY = formatConversion(this.picTableList[i].createAt.toString())
        }
        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    }
  },
  created () {
    this.handleCurrentChange(this.currentPage);

    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {  // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./labelmanage.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}
</style>
